module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', [_vm._v("PRAISE FOR THE WRITING OF EILEEN GOUDGE")]), _vm._v(" "), _c('p', {
    staticClass: "Praise-Quotes"
  }, [_vm._v("“Eileen Goudge writes like a house on fire, creating characters you come to love and hate to leave.”")]), _vm._v(" "), _c('p', {
    staticClass: "Praise-Attr",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_vm._v("—Nora Roberts, #1 "), _c('i', [_vm._v("New York Times")]), _vm._v("–bestselling author")]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('i', [_vm._v("Woman in Red")])]), _vm._v(" "), _c('p', {
    staticClass: "Praise-Quotes"
  }, [_vm._v("“Once you start this wonderful book, you won’t be able to put it down.”")]), _vm._v(" "), _c('p', {
    staticClass: "Praise-Attr",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_vm._v("—Kristin Hannah, "), _c('i', [_vm._v("New York Times")]), _vm._v("–bestselling author")]), _vm._v(" "), _c('p', {
    staticClass: "Praise-Quotes"
  }, [_vm._v("“Beautifully intertwines … two stories, two generations … [Goudge’s] characters are appealing both despite of and because of their problems.”")]), _vm._v(" "), _c('p', {
    staticClass: "Praise-Attr",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_vm._v("—"), _c('i', [_vm._v("Library Journal")])]), _vm._v(" "), _c('p', {
    staticClass: "Praise-Quotes"
  }, [_vm._v("“Eileen Goudge has crafted a beautiful tale of loss, redemption and hope. "), _c('i', [_vm._v("Woman in Red")]), _vm._v(" is a masterpiece.”")]), _vm._v(" "), _c('p', {
    staticClass: "Praise-Attr"
  }, [_vm._v("—Barbara Delinsky, "), _c('i', [_vm._v("New York Times")]), _vm._v("–bestselling author")]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('i', [_vm._v("Blessing in Disguise")])]), _vm._v(" "), _c('p', {
    staticClass: "Praise-Quotes"
  }, [_vm._v("“Powerful, juicy reading.”")]), _vm._v(" "), _c('p', {
    staticClass: "Praise-Attr"
  }, [_vm._v("—"), _c('i', [_vm._v("San Jose Mercury News")])]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('i', [_vm._v("The Diary")])]), _vm._v(" "), _c('p', {
    staticClass: "Praise-Quotes"
  }, [_vm._v("“A lovely book, tender, poignant and touching. It was a joy to read.”")]), _vm._v(" "), _c('p', {
    staticClass: "Praise-Attr"
  }, [_vm._v("—"), _c('i', [_vm._v("Debbie Macomber, New York Times–bestselling author")])]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('i', [_vm._v("Garden of Lies")])]), _vm._v(" "), _c('p', {
    staticClass: "Praise-Quotes"
  }, [_vm._v("“A page-turner … with plenty of steamy sex.”")]), _vm._v(" "), _c('p', {
    staticClass: "Praise-Attr",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_vm._v("—"), _c('i', [_vm._v("New Woman")])]), _vm._v(" "), _c('p', {
    staticClass: "Praise-Quotes"
  }, [_vm._v("“Goes down like a cool drink on a hot day.”")]), _vm._v(" "), _c('p', {
    staticClass: "Praise-Attr"
  }, [_vm._v("—"), _c('i', [_vm._v("Self")])]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('i', [_vm._v("One Last Dance")])]), _vm._v(" "), _c('p', {
    staticClass: "Praise-Quotes"
  }, [_vm._v("“Enlightening and entertaining.”")]), _vm._v(" "), _c('p', {
    staticClass: "Praise-Attr"
  }, [_vm._v("—"), _c('i', [_vm._v("The Plain Dealer")])]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('i', [_vm._v("Such Devoted Sisters")])]), _vm._v(" "), _c('p', {
    staticClass: "Praise-Quotes"
  }, [_vm._v("“Double-dipped passion … in a glamorous, cut-throat world … Irresistible.”")]), _vm._v(" "), _c('p', {
    staticClass: "Praise-Attr"
  }, [_vm._v("—"), _c('i', [_vm._v("San Francisco Chronicle")])]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('i', [_vm._v("Thorns of Truth")])]), _vm._v(" "), _c('p', {
    staticClass: "Praise-Quotes"
  }, [_vm._v("“Goudge’s adroit handling of sex and love should keep her legion of fans well-sated.”")]), _vm._v(" "), _c('p', {
    staticClass: "Praise-Attr"
  }, [_vm._v("—"), _c('i', [_vm._v("Kirkus Reviews")])]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('i', [_vm._v("Woman in Black")])]), _vm._v(" "), _c('p', {
    staticClass: "Praise-Quotes"
  }, [_vm._v("“This novel is the ultimate indulgence—dramatic, involving, and ringing with emotional truth.”")]), _vm._v(" "), _c('p', {
    staticClass: "Praise-Attr"
  }, [_vm._v("—Susan Wiggs, "), _c('i', [_vm._v("New York Times")]), _vm._v("–bestselling author")]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('i', [_vm._v("Woman in Blue")])]), _vm._v(" "), _c('p', {
    staticClass: "Praise-Quotes"
  }, [_vm._v("“Romance, both old and new, abounds. Fans of Goudge’s previous books, romance readers, and lovers of family sagas will enjoy the plot, characters, and resolution.”")]), _vm._v(" "), _c('p', {
    staticClass: "Praise-Attr",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_vm._v("—"), _c('i', [_vm._v("Booklist")])]), _vm._v(" "), _c('p', {
    staticClass: "Praise-Quotes"
  }, [_vm._v("“A touching story with wide appeal.”")]), _vm._v(" "), _c('p', {
    staticClass: "Praise-Attr"
  }, [_vm._v("—"), _c('i', [_vm._v("Publishers Weekly")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e8310108","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/praise.vue
// module id = 60
// module chunks = 0